<template>
    <div class="barChart"></div>
</template>

<script>
    export default {
        name: '',
        props: ["pondsid"],
        data() {
            return {
                myChart: null,
                Xdata: [],
                Ydata: [],
                yAxisMin: null, // 用于存储动态的y轴最小值
            }
        },
        methods: {
            setData() {
                this.request.get("/api/Echart/getpage2", {
                    params: {
                        pondsid: this.pondsid,
                        param: "Ph",
                        number: 10
                    }
                }).then(res => {
                    if (res.code == 200) {
                        let data = res.data;
                        this.Xdata = data.map(item => { // 假设 item.time 是 "2024-03-30T10:03:47"  
                            const timeParts = item.time.split(' '); // 将字符串分割为日期和时间两部分  
                            const datePart = timeParts[0]; // 获取日期部分，即 "2024-03-30"  
                            const timePart = timeParts[1]; // 获取时间部分，即 "10:03:47"  

                            // 从日期部分提取月和日  
                            const month = datePart.substring(5, 7); // "03"  
                            const day = datePart.substring(8, 10); // "30"  

                            // 从时间部分提取时和分  
                            const hour = timePart.substring(0, 2); // "10"  
                            const minute = timePart.substring(3, 5); // "03"  

                            // 拼接成 "月 日 时 分" 的格式  
                            return `${month}-${day} ${hour}:${minute}`;
                        });
                        this.Ydata = data.map(item => item.ph)
                        this.updateDynamicYAxis(); // 计算并更新y轴最小值    
                    }
                    this.setChart()
                })
            },
            updateDynamicYAxis() {
                if (this.Ydata.length > 0) {
                    const minVal = Math.min(...this.Ydata);
                    this.yAxisMin = Math.floor((minVal - 0.3) * 10) / 10; // 减去0.1以确保所有数据都能清晰显示
                }
            },
            setChart() {
                let option = {
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {            // 坐标轴指示器，坐标轴触发有效
                            type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
                        },
                        backgroundColor: '#11367a',
                        textStyle: {
                            color: '#6dd0e3',
                            fontSize: 10,
                        },
                    },
                    legend: {
                        right: "11%",
                        top: "10%",
                        itemWidth: 7,
                        itemHeight: 7,
                        textStyle: {
                            color: '#fff',
                        }
                    },
                    grid: {
                        top: '12%',
                        bottom: '12%',
                        left: "10%",
                        right: '10%',
                        containLabel: false
                    },
                    xAxis: [
                        {
                            type: 'category',
                            boundaryGap: true,
                            axisLine: {
                                symbol: ['none', 'arrow'],
                                symbolSize: [6, 6],
                                symbolOffset: [0, 10],
                                lineStyle: {
                                    color: '#122C49'
                                }
                            },
                            axisTick: { show: false },
                            axisLabel: {
                                color: '#fff',
                                fontSize: 8,
                                interval: 0,
                               
                            },
                            data: this.Xdata,
                        }
                    ],
                    yAxis: [
                        {
                            type: 'value',
                            scale: false,
                            min: this.yAxisMin ? this.yAxisMin : 7.9, // 使用动态最小值
                            // interval: 0.005,
                            
                            axisLine: {
                                symbol: ['none', 'arrow'],
                                symbolSize: [1, 1],
                                lineStyle: {
                                    color: '#122C49'
                                }
                            },
                            axisLabel: {
                                color: '#fff',
                                showMaxLabel: false,
                                fontSize: 10
                            },
                            splitLine: {
                                show: false,
                            },
                            name: 'Ph值',
                            nameGap: -5,
                            nameTextStyle: {
                                color: '#fff',
                                fontSize: 9,
                                align: 'right',
                                padding: [0, 4, 0, 0]
                            },
                        }
                    ],
                    series: [
                        {
                            name: 'Ph值',
                            type: 'bar',
                            itemStyle: {
                                color: {
                                    type: 'linear',
                                    x: 0,
                                    y: 0,
                                    x2: 0,
                                    y2: 1,
                                    colorStops: [{
                                        offset: 0, color: '#50A2F6' // 0% 处的颜色
                                    },
                                    {
                                        offset: 0.4, color: '#9490F9' // 40% 处的颜色
                                    }, {
                                        offset: 1, color: '#DF7DFD' // 100% 处的颜色
                                    }],
                                    global: false // 缺省为 false
                                } //背景渐变色
                            },
                            barWidth: 10,
                            barCategoryGap: 10,
                            data: this.Ydata
                        },
                    ]
                };
                if (!this.myChart) this.myChart = this.$echarts(this.$el);

                this.myChart.clear();
                this.myChart.resize()
                this.myChart.setOption(option);
            }
        },
        mounted() {
            this.setData()
        },
        watch: {
            pondsid() {
                this.setData()
            }
        }
    }
</script>

<style lang="less" scoped>
    .barChart {
        width: 100%;
        height: 100%;
    }
</style>